module.exports = __webpack_public_path__ + "img/pipline_banner_btn.7a1be98f.png";